// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentLinkCheckout_main__dRHGc {
  background-color: var(--color-white);
  max-width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.PaymentLinkCheckout_main__img__cKGiE {
  height: 7rem;
}
.PaymentLinkCheckout_main__titles__t7HF3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60rem;
}
@media only screen and (max-width: 31.25em) {
  .PaymentLinkCheckout_main__titles__t7HF3 {
    width: 42rem;
  }
}
.PaymentLinkCheckout_main__form__WkbP\\+ {
  padding: 4rem 2rem;
  margin: 1rem 3rem;
  border-radius: 2rem;
  width: 100%;
}

.PaymentLinkCheckout_beside__\\+uGjy {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: 2rem;
}
@media only screen and (max-width: 25em) {
  .PaymentLinkCheckout_beside__\\+uGjy {
    grid-template-columns: 100%;
  }
}

.PaymentLinkCheckout_mima__RnmZL {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
}
.PaymentLinkCheckout_mima__RnmZL > :not(:last-child) {
  margin-right: 1rem;
}
.PaymentLinkCheckout_mima__logo__vz1jt {
  height: 3rem;
}

.PaymentLinkCheckout_header__UX2wt {
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding: 2rem 5rem;
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  align-items: center;
  font-size: 2.5rem;
  cursor: pointer;
}
.PaymentLinkCheckout_header__UX2wt img {
  height: 5rem;
}

.PaymentLinkCheckout_checkout__2mpVb {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  box-sizing: border-box;
  position: relative;
}
@media only screen and (max-width: 50em) {
  .PaymentLinkCheckout_checkout__2mpVb {
    grid-template-columns: 100%;
  }
}
.PaymentLinkCheckout_checkout__order__qNM0x {
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
  background-color: #f5f5f5;
  padding: 4rem;
  min-height: 100vh;
  width: 100%;
}
@media only screen and (max-width: 50em) {
  .PaymentLinkCheckout_checkout__order__qNM0x {
    min-height: fit-content;
    grid-row: 1/2;
  }
}
.PaymentLinkCheckout_checkout__order__solid__azlBV {
  width: 50%;
  position: fixed;
  top: 0;
  right: 0;
}
.PaymentLinkCheckout_checkout__order__items__K-U79 {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.PaymentLinkCheckout_checkout__order__item__-vgo- {
  display: grid;
  grid-template-columns: 8rem 1fr 15rem;
  gap: 1rem;
  width: 100%;
  align-items: center;
}
.PaymentLinkCheckout_checkout__order__item__-vgo- > :first-child {
  border: 1px solid #999999;
  padding: 5px;
  border-radius: 1rem;
  position: relative;
}
.PaymentLinkCheckout_checkout__order__item__-vgo- > :first-child img {
  border-radius: 5px;
}
.PaymentLinkCheckout_checkout__order__item__-vgo- > :last-child {
  justify-self: end;
}
.PaymentLinkCheckout_checkout__form__8vT4x {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 4rem;
  min-height: 100vh;
  width: 100%;
}
.PaymentLinkCheckout_checkout__form__beside__\\+vK8C {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.PaymentLinkCheckout_item__quantity__Uja4z {
  position: absolute;
  background-color: #999;
  border-radius: 50%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  color: var(--color-white);
  font-weight: 500;
  top: -1.5rem;
  right: -1.5rem;
  font-size: 1.4rem;
}
.PaymentLinkCheckout_item__totals__r23ri {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.PaymentLinkCheckout_item__totals__r23ri > * {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  align-items: center;
}

.PaymentLinkCheckout_payInfo__SnVwu {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.PaymentLinkCheckout_payInfo__main__Nf3dd {
  padding: 2rem;
  border: 1px solid var(--color-primary);
  width: 100%;
  max-width: 60rem;
  border-radius: 2rem;
  display: grid;
  grid-template-columns: 100%;
  gap: 2rem;
}
.PaymentLinkCheckout_payInfo__main_one__WY0gy {
  grid-column: 1/3;
  padding: 3rem 0;
}
.PaymentLinkCheckout_payInfo__main_text__-3L7c {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.PaymentLinkCheckout_payInfo__main_text2__F8t9s {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.PaymentLinkCheckout_payInfo__main_text2__grid__zMB\\+j {
  display: grid;
  grid-template-columns: 1fr 4rem;
  gap: 1rem;
  width: 100%;
  align-items: center;
}
.PaymentLinkCheckout_payInfo__main_text2__grid__zMB\\+j > :last-child {
  color: var(--color-dark);
  transition: all 1s;
  cursor: pointer;
  font-size: 2rem;
}
.PaymentLinkCheckout_payInfo__main_text2__grid__zMB\\+j > :last-child:hover {
  color: var(--color-primary);
}
.PaymentLinkCheckout_payInfo__info__5Mix5 {
  padding: 2rem;
  width: 55rem;
  border-radius: 2rem;
  background-color: var(--color-primary-3);
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .PaymentLinkCheckout_payInfo__info__5Mix5 {
    width: 40rem;
  }
}
.PaymentLinkCheckout_payInfo__info__5Mix5 > :first-child {
  font-size: 3rem;
}
.PaymentLinkCheckout_payInfo__info2__UQM5S {
  padding: 1rem;
  width: 100%;
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;
  align-items: center;
}
.PaymentLinkCheckout_payInfo__info2__UQM5S > :first-child {
  width: 3rem;
}
.PaymentLinkCheckout_payInfo__nav__vKgYH {
  background-color: var(--color-table-grey-1);
  border-radius: 1rem;
  box-sizing: border-box;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: fit-content;
}
.PaymentLinkCheckout_payInfo__nav__vKgYH > :not(:last-child) {
  margin-bottom: 1rem;
}
.PaymentLinkCheckout_payInfo__nav_item__f0l4B {
  font-size: var(--default-font-small);
  padding: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.PaymentLinkCheckout_payInfo__nav_item__f0l4B img {
  width: 3rem;
}
.PaymentLinkCheckout_payInfo__nav_active__ggYzI {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
  border-radius: 1rem;
}

.PaymentLinkCheckout_span__1jQAu,
.PaymentLinkCheckout_a__stQNO {
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/PaymentLink/PaymentLinkCheckout.module.scss"],"names":[],"mappings":"AAEA;EACC,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADD;AAGC;EACC,YAAA;AADF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAFF;AAIE;EAND;IAOE,YAAA;EADD;AACF;AAIC;EACC,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAFF;;AAMA;EACC,aAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;AAHD;AAKC;EAND;IAOE,2BAAA;EAFA;AACF;;AAKA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAFD;AAIC;EACC,kBAAA;AAFF;AAKC;EACC,YAAA;AAHF;;AAOA;EACC,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAJD;AAMC;EACC,YAAA;AAJF;;AAQA;EACC,aAAA;EACA,qCAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AALD;AAOC;EAPD;IAQE,2BAAA;EAJA;AACF;AAMC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;AAJF;AAME;EATD;IAUE,uBAAA;IACA,aAAA;EAHD;AACF;AAKE;EACC,UAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;AAHH;AAME;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAJH;AAOE;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AALH;AAOG;EACC,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AALJ;AAOI;EACC,kBAAA;AALL;AASG;EACC,iBAAA;AAPJ;AAYC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;AAVF;AAYE;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AAVH;;AAgBC;EACC,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAbF;AAgBC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AAdF;AAgBE;EACC,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;AAdH;;AAmBA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAhBD;AAkBC;EACC,aAAA;EACA,sCAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;AAhBF;AAkBE;EACC,gBAAA;EACA,eAAA;AAhBH;AAmBE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAjBH;AAoBE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAlBH;AAoBG;EACC,aAAA;EACA,+BAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAlBJ;AAoBI;EACC,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAlBL;AAoBK;EACC,2BAAA;AAlBN;AAyBC;EACC,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;AAvBF;AAyBE;EAVD;IAWE,YAAA;EAtBD;AACF;AAwBE;EACC,eAAA;AAtBH;AA0BC;EACC,aAAA;EACA,WAAA;EACA,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAxBF;AA0BE;EACC,WAAA;AAxBH;AA4BC;EACC,2CAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA1BF;AA4BE;EACC,mBAAA;AA1BH;AA6BE;EACC,oCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA3BH;AA6BG;EACC,WAAA;AA3BJ;AA+BE;EACC,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AA7BH;;AAkCA;;EAEC,2BAAA;EACA,gBAAA;AA/BD","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\tbackground-color: var(--color-white);\n\tmax-width: 100vw;\n\tmin-height: 100vh;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\t&__img {\n\t\theight: 7rem;\n\t}\n\n\t&__titles {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\twidth: 60rem;\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\twidth: 42rem;\n\t\t}\n\t}\n\n\t&__form {\n\t\tpadding: 4rem 2rem;\n\t\tmargin: 1rem 3rem;\n\t\tborder-radius: 2rem;\n\t\twidth: 100%;\n\t}\n}\n\n.beside {\n\tdisplay: grid;\n\tgap: 2rem;\n\tgrid-template-columns: repeat(2, 1fr);\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n.mima {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-top: 3rem;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__logo {\n\t\theight: 3rem;\n\t}\n}\n\n.header {\n\twidth: 100%;\n\tborder-bottom: 1px solid #ddd;\n\tpadding: 2rem 5rem;\n\tdisplay: flex;\n\tgap: 2rem;\n\tjustify-content: space-between;\n\talign-items: center;\n\tfont-size: 2.5rem;\n\tcursor: pointer;\n\n\timg {\n\t\theight: 5rem;\n\t}\n}\n\n.checkout {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tposition: relative;\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t&__order {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 3.5rem;\n\t\tbackground-color: #f5f5f5;\n\t\tpadding: 4rem;\n\t\tmin-height: 100vh;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tmin-height: fit-content;\n\t\t\tgrid-row: 1/2;\n\t\t}\n\n\t\t&__solid {\n\t\t\twidth: 50%;\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t}\n\n\t\t&__items {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 2rem;\n\t\t}\n\n\t\t&__item {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 8rem 1fr 15rem;\n\t\t\tgap: 1rem;\n\t\t\twidth: 100%;\n\t\t\talign-items: center;\n\n\t\t\t& > :first-child {\n\t\t\t\tborder: 1px solid #999999;\n\t\t\t\tpadding: 5px;\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tposition: relative;\n\n\t\t\t\timg {\n\t\t\t\t\tborder-radius: 5px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& > :last-child {\n\t\t\t\tjustify-self: end;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t\tpadding: 4rem;\n\t\tmin-height: 100vh;\n\t\twidth: 100%;\n\n\t\t&__beside {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\tgap: 2rem;\n\t\t}\n\t}\n}\n\n.item {\n\t&__quantity {\n\t\tposition: absolute;\n\t\tbackground-color: #999;\n\t\tborder-radius: 50%;\n\t\tpadding: 1rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: 3rem;\n\t\theight: 3rem;\n\t\tcolor: var(--color-white);\n\t\tfont-weight: 500;\n\t\ttop: -1.5rem;\n\t\tright: -1.5rem;\n\t\tfont-size: 1.4rem;\n\t}\n\n\t&__totals {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\n\t\t& > * {\n\t\t\tdisplay: flex;\n\t\t\tgap: 2rem;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n\n.payInfo {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\t&__main {\n\t\tpadding: 2rem;\n\t\tborder: 1px solid var(--color-primary);\n\t\twidth: 100%;\n\t\tmax-width: 60rem;\n\t\tborder-radius: 2rem;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 100%;\n\t\tgap: 2rem;\n\n\t\t&_one {\n\t\t\tgrid-column: 1/3;\n\t\t\tpadding: 3rem 0;\n\t\t}\n\n\t\t&_text {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\t&_text2 {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\n\t\t\t&__grid {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 1fr 4rem;\n\t\t\t\tgap: 1rem;\n\t\t\t\twidth: 100%;\n\t\t\t\talign-items: center;\n\n\t\t\t\t& > :last-child {\n\t\t\t\t\tcolor: var(--color-dark);\n\t\t\t\t\ttransition: all 1s;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tfont-size: 2rem;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&__info {\n\t\tpadding: 2rem;\n\t\twidth: 55rem;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-primary-3);\n\t\tdisplay: grid;\n\t\tgrid-template-columns: max-content 1fr;\n\t\tgap: 1rem;\n\t\tmargin-bottom: 2rem;\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\twidth: 40rem;\n\t\t}\n\n\t\t& > :first-child {\n\t\t\tfont-size: 3rem;\n\t\t}\n\t}\n\n\t&__info2 {\n\t\tpadding: 1rem;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: max-content 1fr;\n\t\tgap: 1rem;\n\t\tmargin-bottom: 2rem;\n\t\tfont-size: 1.4rem;\n\t\talign-items: center;\n\n\t\t& > :first-child {\n\t\t\twidth: 3rem;\n\t\t}\n\t}\n\n\t&__nav {\n\t\tbackground-color: var(--color-table-grey-1);\n\t\tborder-radius: 1rem;\n\t\tbox-sizing: border-box;\n\t\tpadding: 1rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: fit-content;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\t&_item {\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tpadding: 1rem;\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 1rem;\n\n\t\t\timg {\n\t\t\t\twidth: 3rem;\n\t\t\t}\n\t\t}\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tfont-weight: 700;\n\t\t\tborder-radius: 1rem;\n\t\t}\n\t}\n}\n\n.span,\n.a {\n\tcolor: var(--color-primary);\n\tfont-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `PaymentLinkCheckout_main__dRHGc`,
	"main__img": `PaymentLinkCheckout_main__img__cKGiE`,
	"main__titles": `PaymentLinkCheckout_main__titles__t7HF3`,
	"main__form": `PaymentLinkCheckout_main__form__WkbP+`,
	"beside": `PaymentLinkCheckout_beside__+uGjy`,
	"mima": `PaymentLinkCheckout_mima__RnmZL`,
	"mima__logo": `PaymentLinkCheckout_mima__logo__vz1jt`,
	"header": `PaymentLinkCheckout_header__UX2wt`,
	"checkout": `PaymentLinkCheckout_checkout__2mpVb`,
	"checkout__order": `PaymentLinkCheckout_checkout__order__qNM0x`,
	"checkout__order__solid": `PaymentLinkCheckout_checkout__order__solid__azlBV`,
	"checkout__order__items": `PaymentLinkCheckout_checkout__order__items__K-U79`,
	"checkout__order__item": `PaymentLinkCheckout_checkout__order__item__-vgo-`,
	"checkout__form": `PaymentLinkCheckout_checkout__form__8vT4x`,
	"checkout__form__beside": `PaymentLinkCheckout_checkout__form__beside__+vK8C`,
	"item__quantity": `PaymentLinkCheckout_item__quantity__Uja4z`,
	"item__totals": `PaymentLinkCheckout_item__totals__r23ri`,
	"payInfo": `PaymentLinkCheckout_payInfo__SnVwu`,
	"payInfo__main": `PaymentLinkCheckout_payInfo__main__Nf3dd`,
	"payInfo__main_one": `PaymentLinkCheckout_payInfo__main_one__WY0gy`,
	"payInfo__main_text": `PaymentLinkCheckout_payInfo__main_text__-3L7c`,
	"payInfo__main_text2": `PaymentLinkCheckout_payInfo__main_text2__F8t9s`,
	"payInfo__main_text2__grid": `PaymentLinkCheckout_payInfo__main_text2__grid__zMB+j`,
	"payInfo__info": `PaymentLinkCheckout_payInfo__info__5Mix5`,
	"payInfo__info2": `PaymentLinkCheckout_payInfo__info2__UQM5S`,
	"payInfo__nav": `PaymentLinkCheckout_payInfo__nav__vKgYH`,
	"payInfo__nav_item": `PaymentLinkCheckout_payInfo__nav_item__f0l4B`,
	"payInfo__nav_active": `PaymentLinkCheckout_payInfo__nav_active__ggYzI`,
	"span": `PaymentLinkCheckout_span__1jQAu`,
	"a": `PaymentLinkCheckout_a__stQNO`
};
export default ___CSS_LOADER_EXPORT___;
